export const formatYValue = (
  value: string,
  marginLeft: number,
  numberOfSegments: number
): string => (marginLeft === 1 && numberOfSegments > 1 ? `${value.trim()} Total` : value.trim());

export const formatYAxisTickLabel = (total: boolean, newValue: string): string => {
  if (total) {
    return 'Total';
  }
  return newValue.includes(',') ? newValue.split(',').join(', ') : newValue;
};

interface NormalizableBar {
  segmentName: string;
  totalCleared: number;
  totalProjected: number;
  totalRemainder: number;
  budget: number;
}

// Scales a bar's segments to fractions of the full bar: a ratio goal fills against its budget,
// anything else against the sum of its segments.
export const normalizePacingBar = (item: NormalizableBar, isDerived: boolean) => {
  if (isDerived) {
    const goal = item.budget || 1;
    const clearedRatio = item.totalCleared / goal;
    return {
      segmentName: item.segmentName,
      totalCleared: clearedRatio,
      totalProjected: 0,
      totalRemainder: Math.max(0, 1 - clearedRatio)
    };
  }
  const segmentTotal = item.totalCleared + item.totalProjected + item.totalRemainder;
  return {
    segmentName: item.segmentName,
    totalCleared: item.totalCleared / segmentTotal,
    totalProjected: item.totalProjected / segmentTotal,
    totalRemainder: item.totalRemainder / segmentTotal
  };
};

// A label wider than its segment would overlap its neighbors and clip.
export const layerLabelFits = (segmentWidth: number, labelWidth: number, padding: number) =>
  segmentWidth >= labelWidth + padding;

interface Point {
  x: number;
  y: number;
}

interface Size {
  width: number;
  height: number;
}

// Places an overlay next to the cursor, flipping to the other side of it when it would run off
// the viewport, and never past the top-left corner.
export const placeCursorOverlay = (
  cursor: Point,
  overlay: Size,
  viewport: Size,
  offset: number
): Point => {
  let left = cursor.x + offset;
  if (left + overlay.width > viewport.width) {
    left = cursor.x - offset - overlay.width;
  }
  let top = cursor.y + offset;
  if (top + overlay.height > viewport.height) {
    top = cursor.y - offset - overlay.height;
  }
  return { x: Math.max(left, 0), y: Math.max(top, 0) };
};
